exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style__ModalWrapper___3iH6M {\n  border-radius: 20px;\n  min-width: 800px;\n  min-height: 500px; }\n\n.style__Header___3kWIk {\n  color: #4ec1e0;\n  height: 63px;\n  font-size: 20px;\n  font-weight: 500;\n  background-color: #404040;\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n  -webkit-box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);\n          box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);\n  border-bottom: solid 6px #4ec1e0; }\n\n.style__Body___HYChn {\n  background: white;\n  border-bottom-left-radius: 20px;\n  border-bottom-right-radius: 20px; }\n", ""]);

// exports
exports.locals = {
	"ModalWrapper": "style__ModalWrapper___3iH6M",
	"Header": "style__Header___3kWIk",
	"Body": "style__Body___HYChn"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/component/Modal/style.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/component/Modal/style.css
// module chunks = 0